import React, {Component} from 'react';
import compose from 'recompose/compose';
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/core/styles';
import classNames from 'classnames';
import _ from 'lodash';
import {
	getAsnHenkanList,
	changeCurrentPath,
	resetMainListState,
	resetConsigneeListStateNew,
	getAsnList,
	setAsnHenkanList,
	resetMasterAsnHenkan,
	fetchCsvMasterAsnHenkan,
	getKeiyakuKigyouList
} from '../../../actions';

import Header from '../../../common/containers/header';
import Progress from '../../../common/containers/progress'
import SpNav from '../../../common/containers/sp_nav'
import Footer from '../../../common/containers/footer';

import ErrorDialog from '../../../common/components/dialog/error-dialog';
import ReloadModal from '../../../common/components/dialog/reload-dialog';
import LogoutModal from '../../../common/components/dialog/logout-dialog';

import MainButtons from '../../../common/components/main-buttons';

import MasterTable from '../../../common/components/table/master-table';
import AlertDialog from '../../../common/components/dialog/alert-dialog';

const styles = theme => ({
	buttonHide: {
		position: 'absolute',
		top: 0,
		backgroundColor: '#FFFFFF',
		height: '100%',
		zIndex: 6,
	},
	buttonHideLeft: {
		left: -20,
		width: 20
	},
	buttonHideRight: {
		right: -100,
		width: 100
	},
	cautionText: {
		marginTop: -20,
		color: '#f90c0c'
	}
});

let columns = [
	{name: 'AsnCD_Obj', title: 'ASN連携先コード', width: 300, maxLength: 13, defaultValue: '', validations: ["required"]},
	{name: 'HenkanKbn', title: '変換区分', width: 150, defaultValue: '1'},
	{
		name: 'KeiyakuKigyouCD_Obj',
		title: '契約企業コード',
		width: 300,
		maxLength: 13,
		defaultValue: '',
		validations: ["required"]
	},
	{name: 'HenkanmotoCD', title: '変換元コード', width: 150, maxLength: 13, defaultValue: '', validations: ["required"]},
	{name: 'HenkansakiCD', title: '変換先コード', width: 150, maxLength: 30, defaultValue: '', validations: ["required"]}
];

let suggestionColumns = {
	AsnCD_Obj: [],
	KeiyakuKigyouCD_Obj: []
};

let selectableColumns = {
	HenkanKbn: [{value: "1", name: "DEPO"}, {value: "2", name: "メーカー"}]
};

class MasterAsnHenkan extends Component {

	constructor(props) {
		super(props);
		this.state = {
			rows: [],
			onEdit: false,
			isModify: false,
			dialogOpen: false,
			dialogOpenSave: false,
		}
	}

	/** override methods **/
	UNSAFE_componentWillMount() {
		const {dispatch} = this.props;
		this.getAsnHenkanList();
		dispatch(getAsnList());
		dispatch(getKeiyakuKigyouList());
		dispatch(resetMainListState());
		dispatch(resetConsigneeListStateNew());

	}

	componentDidMount() {
		const {dispatch, history} = this.props;
		dispatch(changeCurrentPath({currentPath: history.location.pathname}));
	}

	componentWillUnmount() {
		const {dispatch} = this.props;
		dispatch(resetMasterAsnHenkan());
	}

	/** event handlers **/
	handleClickSave = () => {
		const {auth, dispatch} = this.props;
		const {rows} = this.state;
		const addRow = _.filter(rows, {isAdd: true});
		const updateRow = _.filter(rows, (row) => {
			return row.isChange || row.isUpdateDelete
		});
		dispatch(setAsnHenkanList({
			addRow,
			updateRow,
			SessionID: auth.SessionID
		}));
	};

	handleClickClear = () => {
		const {onEdit, isModify} = this.state;
		if (onEdit || isModify) {
			this.setState({
				dialogOpen: true
			});
		} else {
			this.getAsnHenkanList();
		}
	};

	doClear = () => {
		this.setState({
			dialogOpen: false
		});
		this.getAsnHenkanList();
	};

	cancelClear = () => {
		this.setState({
			dialogOpen: false
		});
	};

	handleGetCurrentList = ({rows, addedRows, editRows}) => {
		const onEdit = (Object.keys(addedRows).length > 0) || (Object.keys(editRows).length > 0);
		const isModify = rows.some(row => {
			return row.isAdd || row.isChange || row.isUpdateDelete
		});
		this.setState({rows, onEdit, isModify});
	};

	handleClickDL = () => {
		const {dispatch} = this.props;
		dispatch(fetchCsvMasterAsnHenkan());
	};

	getAsnHenkanList() {
		const {dispatch} = this.props;
		dispatch(getAsnHenkanList());
	}

	render() {
		const {settings, classes} = this.props;
		const {onEdit, isModify, dialogOpen} = this.state;

		const disabled = onEdit || !(isModify);
		const mainButtons = [
			{type: 'SAVE', func: this.handleClickSave, disabled},
			{type: 'CLEAR', func: this.handleClickClear},
			{type: 'DL', func: this.handleClickDL, hasMargin: true},
		];

		const rows = settings.data;
		suggestionColumns["AsnCD_Obj"] = settings.asnData.map(
			suggestion => ({
				value: suggestion.ASNRenkeiCD,
				label: suggestion.ASNRenkeiCD + ' : ' + suggestion.ASNRenkeiName,
			}));

		suggestionColumns["KeiyakuKigyouCD_Obj"] = settings.keiyakukigyouData.map(
			suggestion => ({
				value: suggestion.KeiyakuKigyouCD,
				label: suggestion.KeiyakuKigyouCD + ' : ' + suggestion.KeiyakuKigyouName,
			}));

		return (
			<div id="main_container">
				{settings.isFetching &&
				<Progress/>
				}
				<SpNav history={this.props.history}/>
				<Header history={this.props.history}/>
				<article>
					<section className="title_area">
						<h2>ASNコード変換</h2>
					</section>
					<section className="with_button">
						<div className={classNames(classes.buttonHide, classes.buttonHideLeft)}/>
						<div className={classNames(classes.buttonHide, classes.buttonHideRight)}/>
						<MasterTable
							dataSource={rows}
							columns={columns}
							selectableColumns={selectableColumns}
							suggestionColumns={suggestionColumns}
							defaultSorts={[{columnName: 'ASNRenkeiCD', direction: 'asc'}, {
								columnName: 'HenkanKbn',
								direction: 'asc'
							}, {columnName: 'KeiyakuKigyouCD', direction: 'asc'}]}
							getCurrentState={this.handleGetCurrentList}
						/>
					</section>
				</article>
				<MainButtons buttons={mainButtons}/>
				<Footer/>

				<AlertDialog
					open={dialogOpen}
					title={"確認"}
					text={<span>編集中の内容は破棄されます</span>}
					okFunction={this.doClear}
					closeFunction={this.cancelClear}
				/>
				<ErrorDialog
					open={settings.isProcessError}
				/>
				<ReloadModal/>
				<LogoutModal/>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		navigation: state.navigation,
		auth: state.auth,
		settings: state.masterAsnHenkanSettings,
	};
}

export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(MasterAsnHenkan);



// WEBPACK FOOTER //
// ./src/routes/master/asncode-henkan/index.js